import { gql } from "@apollo/client";

export const GET_PREQUALIFICATION_CHECKOUT_URL = gql`
  query PrequalificationCheckoutUrl($prequalificationId: String!) {
    prequalificationCheckoutUrl(prequalificationId: $prequalificationId)
  }
`;
